import styled from "styled-components";
import { Flex as RebassFlex } from "rebass";
import { maxWidth, minWidth, textAlign, display, opacity, position } from "styled-system";

const Flex = styled(RebassFlex)(maxWidth, minWidth, textAlign, display, opacity, position);

export default Flex;
